import getLocation from 'services/api/utility/getLocation';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const { StorageTypes } = Storage;
const inFlightRequests = new Map();

function getLocationWithCache(params = {}) {
    const cacheKey = LOCAL_STORAGE.LOCATION_CACHE_KEY + (params.radius || 'default');

    if (inFlightRequests.has(cacheKey)) {
        return inFlightRequests.get(cacheKey);
    }

    const request = getLocation(params, {
        cache: {
            key: cacheKey,
            expiry: Storage.SECONDS * 15,
            storageType: StorageTypes.Session
        }
    }).finally(() => {
        inFlightRequests.delete(cacheKey);
    });

    inFlightRequests.set(cacheKey, request);

    return request;
}

export default getLocationWithCache;
